function receiptRewardsProductsController($scope, $timeout, $element, BreakpointsService, carouselConfig) {
    const $ctrl = this;
    
    // we want to display products as grid on desktop
    // and scroller on mobile
    // angular-slick is 'enable' via bindings
    // however, angular-slick unable to re-apply when change from desktop -> mobile
    function resetSlick() {
        const isSmallFormat = $scope.vm.isSmallFormat;
        const slickElement = $element.find('.slick-initialized');

        if (!isSmallFormat && slickElement) {
            slickElement.remove('slick-list');
            slickElement.slick('unslick');
        }
    }

    $ctrl.$onInit = function() {
        // set default bindings
        $scope.vm.productCategory = $scope.vm.productCategory || '';
        $scope.vm.divider = typeof $scope.vm.divider === 'boolean'
            ? $scope.vm.divider
            : false;
        $scope.vm.productData = $scope.vm.productData || [];
        $scope.vm.isSmallFormat = BreakpointsService.isSmallFormat();
        $scope.vm.slickConfigLoaded = true;
        $scope.vm.slickConfig = carouselConfig || {};
        resetSlick();
    };

    $scope.$on('window:resize', function () {
        $timeout(function () {
            const isSmallFormat = BreakpointsService.isSmallFormat();
            $scope.vm.isSmallFormat = isSmallFormat;
            resetSlick();
        });
    });
 }

 module.exports = {
    bindings: {
        productCategory: '@',
        divider: '<',
        productData: '<'
    },
    controllerAs: 'vm',
    controller: [
        '$scope',
        '$timeout',
        '$element',
        'BreakpointsService',
        'carouselConfig',
        receiptRewardsProductsController
    ],
    template: require('./receipt-rewards-products.html')
 };



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/receipt-rewards/receipt-rewards-products.js
 **/